module.exports = {
    loc: {
        assetsURL: 'http://localhost.semprefamilia.com.br:3000',
        siteURL: 'http://localhost.semprefamilia.com.br:3000/semprefamilia',
        loginURL: 'https://conta.development.gazetadopovo.com.br/login',
        subDomain: 'development',
        cookieDomain: 'development.semprefamilia.com.br',
        // URL de APIS
        services: {
            hub: 'https://3wf9o7mmzc.execute-api.us-east-1.amazonaws.com/prd',
            account: {
                url: 'https://account.staging.gazetadopovo.com.br',
                apiKey: 'SRhaFK75du2cIiaTxSllh60geKZNbkyy6wQpIGgO'
            },
            notification: {
                url: 'https://notifications-user-api-dev.gazetadopovo.com.br',
                apiKey: 'UbX0I1CnsL8PU83BgRrPv4BpMHiu2nphadVyiUKn'
            },
            comments: 'https://kz21ppimrg.execute-api.us-east-1.amazonaws.com/stg',
            // comments: 'http://development.semprefamilia.com.br:3001',
            events: 'https://events.development.gazetadopovo.com.br',
            reactions: 'https://social.development.gazetadopovo.com.br',
            temporeal: 'https://temporeal.gazetadopovo.com.br',
            lancealance: 'https://temporeal.gazetadopovo.com.br',
            faleConosco: 'https://n9hw6xa5z0.execute-api.us-east-1.amazonaws.com/dev',
            apps: 'https://apps.gazetadopovo.com.br',
            statsPoints: 'https://3r5o90l2d2.execute-api.us-east-1.amazonaws.com/stg',
            tagSearch: 'https://usvvhbajbb.execute-api.us-east-1.amazonaws.com/prd',
            jsons: 'http://localhost.semprefamilia.com.br:3000/caixa/semprefamilia',
            widgetSocialHome: 'https://www.gazetadopovo.com.br/json/widgets/home/social.json',
            cookieExchanger: {
                login: [
                    'http://localhost.umdoisesportes.com.br:3003/'
                ],
                piano: [
                    'http://localhost.gazetadopovo.com.br:3003/'
                ]
            },
            readingShare: 'https://services.development.gazetadopovo.com.br/reading-share',
            social: 'https://41fxggad6e.execute-api.us-east-1.amazonaws.com/dev',
            notifications: 'https://jiweafsuni.execute-api.us-east-1.amazonaws.com/stg',
            savedItems: 'https://wlkkhe4l5i.execute-api.us-east-1.amazonaws.com/stg'
        }
    },

    dev: {
        assetsURL: 'https://development.semprefamilia.com.br/assets2',
        siteURL: 'https://development.semprefamilia.com.br',
        loginURL: 'https://conta.development.gazetadopovo.com.br/login',
        subDomain: 'development',
        cookieDomain: 'development.semprefamilia.com.br',
        services: {
            // hub: 'https://p9t6z2s19j.execute-api.us-east-1.amazonaws.com/stg',
            hub: 'https://3wf9o7mmzc.execute-api.us-east-1.amazonaws.com/prd',
            account: {
                url: 'https://account.staging.gazetadopovo.com.br',
                apiKey: 'SRhaFK75du2cIiaTxSllh60geKZNbkyy6wQpIGgO'
            },
            notification: {
                url: 'https://notifications-user-api-dev.gazetadopovo.com.br',
                apiKey: 'UbX0I1CnsL8PU83BgRrPv4BpMHiu2nphadVyiUKn'
            },
            comments: 'https://kz21ppimrg.execute-api.us-east-1.amazonaws.com/stg',
            events: 'https://events.development.gazetadopovo.com.br',
            reactions: 'https://social.development.gazetadopovo.com.br',
            temporeal: 'https://temporeal.gazetadopovo.com.br',
            lancealance: 'https://temporeal.gazetadopovo.com.br',
            faleConosco: 'https://n9hw6xa5z0.execute-api.us-east-1.amazonaws.com/dev',
            apps: 'https://apps.gazetadopovo.com.br',
            statsPoints: 'https://3r5o90l2d2.execute-api.us-east-1.amazonaws.com/stg',
            tagSearch: 'https://yc3en5njqe.execute-api.us-east-1.amazonaws.com/dev',
            jsons: 'https://development.semprefamilia.com.br/json',
            widgetSocialHome: 'https://www.gazetadopovo.com.br/json/widgets/home/social.json',
            cookieExchanger: {
                login: [],
                piano: [
                    'https://development.gazetadopovo.com.br/cookie-exchanger/'
                ]
            },
            readingShare: 'https://services.development.gazetadopovo.com.br/reading-share',
            social: 'https://41fxggad6e.execute-api.us-east-1.amazonaws.com/dev',
            notifications: 'https://jiweafsuni.execute-api.us-east-1.amazonaws.com/stg',
            savedItems: 'https://j21vmhzujb.execute-api.us-east-1.amazonaws.com/dev'
        }
    },

    stg: {
        assetsURL: 'https://staging.semprefamilia.com.br/assets2',
        siteURL: 'https://staging.semprefamilia.com.br',
        loginURL: 'https://conta.gazetadopovo.com.br/login',
        subDomain: 'staging',
        cookieDomain: '.semprefamilia.com.br',
        services: {
            hub: 'https://3wf9o7mmzc.execute-api.us-east-1.amazonaws.com/prd',
            account: {
                hub: '',
                url: 'https://account.staging.gazetadopovo.com.br',
                apiKey: 'SRhaFK75du2cIiaTxSllh60geKZNbkyy6wQpIGgO'
            },
            notification: {
                url: 'https://notifications-user-api.gazetadopovo.com.br',
                apiKey: '9HeAD3tb8M1eZcyGHO3BXau6G68SEcAJ8MRsxLGx'
            },
            comments: 'https://kz21ppimrg.execute-api.us-east-1.amazonaws.com/stg',
            events: 'https://events.staging.gazetadopovo.com.br',
            reactions: 'https://social.staging.gazetadopovo.com.br',
            temporeal: 'https://temporeal.gazetadopovo.com.br',
            lancealance: 'https://temporeal.gazetadopovo.com.br',
            faleConosco: 'https://3xq058rs9h.execute-api.us-east-1.amazonaws.com/stg',
            apps: 'https://apps.gazetadopovo.com.br',
            statsPoints: 'https://3r5o90l2d2.execute-api.us-east-1.amazonaws.com/stg',
            tagSearch: 'https://onti380za4.execute-api.us-east-1.amazonaws.com/stg',
            jsons: 'https://staging.semprefamilia.com.br/json',
            widgetSocialHome: 'https://staging.gazetadopovo.com.br/json/widgets/home/social.json',
            cookieExchanger: {
                login: [],
                piano: [
                    'https://staging.gazetadopovo.com.br/cookie-exchanger/'
                ]
            },
            readingShare: 'https://services.staging.gazetadopovo.com.br/reading-share',
            social: 'https://41fxggad6e.execute-api.us-east-1.amazonaws.com/dev',
            notifications: 'https://jiweafsuni.execute-api.us-east-1.amazonaws.com/stg',
            savedItems: 'https://wlkkhe4l5i.execute-api.us-east-1.amazonaws.com/stg'
        }
    },

    prd: {
        assetsURL: 'https://www.semprefamilia.com.br/assets2',
        siteURL: 'https://www.semprefamilia.com.br',
        loginURL: 'https://conta.gazetadopovo.com.br/login',
        subDomain: 'www',
        cookieDomain: '.semprefamilia.com.br',
        services: {
            hub: 'https://3wf9o7mmzc.execute-api.us-east-1.amazonaws.com/prd',
            account: {
                url: 'https://account-api.gazetadopovo.com.br',
                apiKey: '9HeAD3tb8M1eZcyGHO3BXau6G68SEcAJ8MRsxLGx'
            },
            notification: {
                url: 'https://notifications-user-api-dev.gazetadopovo.com.br',
                apiKey: 'UbX0I1CnsL8PU83BgRrPv4BpMHiu2nphadVyiUKn'
            },
            comments: 'https://comments.gazetadopovo.com.br',
            events: 'https://events-api.gazetadopovo.com.br',
            reactions: 'https://social.gazetadopovo.com.br',
            temporeal: 'https://temporeal.gazetadopovo.com.br',
            lancealance: 'https://temporeal.gazetadopovo.com.br',
            faleConosco: 'https://oh9u1d1by3.execute-api.us-east-1.amazonaws.com/prd',
            apps: 'https://apps.gazetadopovo.com.br',
            statsPoints: 'https://6ql752f547.executeapi.us-east-1.amazonaws.com/prd',
            tagSearch: 'https://usvvhbajbb.execute-api.us-east-1.amazonaws.com/prd',
            jsons: 'https://www.gazetadopovo.com.br/json',
            widgetSocialHome: 'https://www.gazetadopovo.com.br/json/widgets/home/social.json',
            cookieExchanger: {
                login: [],
                piano: [
                    'https://www.gazetadopovo.com.br/cookie-exchanger/'
                ]
            },
            readingShare: 'https://services.gazetadopovo.com.br/reading-share',
            notifications: 'https://1ci9nqe6hc.execute-api.us-east-1.amazonaws.com/prd',
            savedItems: 'https://ux2az240me.execute-api.us-east-1.amazonaws.com/prd'
        }
    },

    // Variáveis que não se alteram por ambiente
    commons: {
        publisherId: '94e6bf84-f14c-11e7-8c3f-9a214cf093ae'
    }
}